import { Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { updateBuilding } from 'shared/api/buildings';
import internetDescriptions from 'shared/components/data-display/internetDescriptions';
import { DataFormatter } from 'shared/components/data-display/DataFormatter';
import { NumberEditor } from 'shared/components/data-display/editors';
import { VARIANTS } from 'shared/constants';
import { useRequest } from 'shared/hooks';
import ConfigScript from 'features/networking/building/ConfigScript';
import { DataReducerActions } from 'shared/reducers';

const descriptions = [
  ...internetDescriptions,
  {
    label: 'VLAN Start',
    key: 'vlan_range_start',
    editor: NumberEditor,
    readOnly: true,
  },
  {
    label: 'VLAN End',
    key: 'vlan_range_end',
    editor: NumberEditor,
    readOnly: true,
  },
];

/**
 * @param {Object} props
 * @param {Object} props.state - State object containing building data
 * @param {Function} props.dispatch - Dispatch function for reducer actions
 */
export default function BasicInfo({ state, dispatch }) {
  const { request } = useRequest();

  const [valid, setValid] = useState(false);

  const {
    data: building,
    dirty,
    updatedData,
  } = state;
  const {
    id,
  } = building || {};

  useEffect(() => {
    if (Object.keys(updatedData).length > 0) {
      const isValid = Object.values(updatedData).find((value) => value === null);
      setValid(isValid === undefined);
    }
  }, [updatedData]);

  const save = async () => {
    const response = await request(
      updateBuilding(id, updatedData),
      `Changes saved for ${building.name}`,
      `Issue saving data for ${building.name}`,
    );
    if (response) {
      dispatch({
        action: DataReducerActions.set,
        payload: response,
      });
    }
  };

  if (building === undefined) return null;
  return (
    <>
      <DataFormatter
        data={building}
        descriptions={descriptions}
        editing
        updatedData={updatedData}
        updateValue={(key, value) => dispatch({
          action: DataReducerActions.update,
          payload: {
            key,
            value,
          },
        })}
      />
      <Box
        sx={{
          width: '100%',
          pt: '10px',
          display: 'flex',
          justifyContent: 'end',
          gap: 1,
        }}
      >
        {dirty ? (
          <>
            <Button
              variant={VARIANTS.outlined}
              onClick={() => dispatch({ action: DataReducerActions.clear })}
            >
              Clear
            </Button>
            <Button
              disabled={!valid}
              onClick={save}
              variant={VARIANTS.contained}
            >
              Save
            </Button>
          </>
        ) : (
          <ConfigScript building={building} />
        )}
      </Box>
    </>
  );
}
